'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeSurfaceIcon = function TraceTypeSurfaceIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement(
                'linearGradient',
                { id: 'a', x1: '23.445', y1: '12.605', x2: '23.445', y2: '28.002', gradientUnits: 'userSpaceOnUse' },
                _react2.default.createElement('stop', { offset: '0', stopColor: '#1d9cfc' }),
                _react2.default.createElement('stop', { offset: '1', stopColor: '#25fdfc' })
            )
        ),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', stroke: '#1d9bfb', d: 'M23.511 23.571l.005-15.302L37 14.295v15.75l-13.489-6.474z', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: '#25fdfc', stroke: '#1d9bfb', d: 'M23.511 23.571L9.516 30.045l13.929 6.319L37 30.045l-13.489-6.474z', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: '#25fdfc', stroke: '#1d9bfb', d: 'M9.516 30.045v-15.75l13.999-6.026-.004 15.302-13.995 6.474z', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
        _react2.default.createElement('path', { d: 'M16.565 29.746c1.795-.942 3.07-4.294 3.07-9.292a3.81 3.81 0 1 1 7.62 0c0 4.998 1.275 8.35 3.07 9.292', stroke: '#1d9bfb', fill: 'url(#a)', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' })
    );
};

exports.default = TraceTypeSurfaceIcon;